export const STATSIG_SEARCH_BAR_CLICK = 'All - All - Click - Search Bar';
